<template>
  <div class="payment-page">
    <nav-header module="支付"></nav-header>
    <div class="container">
      <div class="title-module">
        <h2 class="title">
          <i class="icon"></i>
          支付
        </h2>
        <div class="fr">
          <span class="label">支付金额：</span>
          <span class="count" v-if="payInfo"><i class="unit">￥</i>{{payInfo.PayAmount | formatPrice}}</span>
        </div>
        <div class="pay-info">
          <span class="pay-name">{{payInfo.Title}}</span>
          <span class="order-no">单号： {{payInfo.Number}}</span>
        </div>
      </div>
      <div class="form">
        <div class="form-item">
          <span class="label">支付方式：</span>
          <div class="input-box">
            <template  v-for="(item,index) in payType">
              <label class="radiobox" v-if="item.isShow" :key="index">
                <input class="radio" type="radio" name="type" :value="item.id" v-model="typeId">
                <div class="radio-block">
                  <span class="icon-payment" :style="{'background-image':'url('+item.icon+')'}"></span>
                  <span class="text">{{item.label}}</span>
                  <span class="value" v-if="item.id == 2 || item.id == 4">￥{{item.value | formatPrice}}</span>
                </div>
              </label>
            </template>
          </div>
        </div>
      </div>
      <button class="btn-primary" @click="nextStep">下一步</button>
    </div>
    <gk-dialog class="wxpay-dialog" title="支付" width="400px" :show="isShowQrcode" @close="clearWeiXin">
      <div class="name">支付金额：<i class="price">￥{{count}}</i></div>
      <canvas class="qrcode" ref="qrcode"></canvas>
      <span class="desc">微信支付</span>
    </gk-dialog>
  </div>
</template>
<script>
import navHeader from '@/components/navHeader.vue'
import Dialog from "@/components/gkDialog.vue";
import {
  AliConfirmRecharge,
  WeixinUnifiedorderByPC,
  GetAccountPayInfo,
  CreditPay,
  BalancePay,

  PcAliPay,      //支付宝支付接口
  PcWeiXinPay,          //微信支付
  WeiXinQueryOrder,   //微信支付是否成功
} from "@/scripts/api.js";
import {
    getQueryString,
} from '@/scripts/util.js'
import {aesEncrypt} from '@/scripts/aesHelper.js'
import { mapState,mapActions } from "vuex";
import QRCode from "qrcode";
export default {
  components:{
    navHeader,
    "gk-dialog": Dialog,
  },
  data(){
    return{
      typeId:0,
      qrcode:'',
      isShowQrcode:false,
      payInfo:{},
      from:0,//1发单，2工单详情,3急单支付,4 培训课程
      time: null,
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      // accountBalance:(state) => state.accountBalance,
    }),
    payType(){
      let arr=[{
        id:2,
        icon:require('@/assets/balance/payBalance.png'),
        label:'余额支付',
        value:0,
        isShow:true,
      },{
        id:4,
        icon:require('@/assets/balance/payCredit.png'),
        label:'额度支付',
        value:0,
        isShow:true,
      },{
        id:1,
        icon:require('@/assets/balance/payAlipay.png'),
        label:'支付宝',
        value:0,
        isShow:true,
      },{
        id:3,
        icon:require('@/assets/balance/weChatPay.png'),
        label:'微信',
        value:0,
        isShow:true,
      }]
      if(this.payInfo){
        arr[1].value=this.payInfo.CreditLineMpValue;
        arr[1].isShow=this.payInfo.IsCreditEnterprise;
        arr[0].isShow=!this.payInfo.IsCreditEnterprise;
        arr[0].value=this.payInfo.MpValue;
        arr[2].isShow=!this.payInfo.IsCreditEnterprise;
        arr[3].isShow=!this.payInfo.IsCreditEnterprise;
        if(this.payInfo.PayAmount<=0) {
          arr[2].isShow= false
          arr[3].isShow= false
        }
        if(this.payInfo.ContentType==50
        &&this.payInfo.JobType==1
        &&this.payInfo.MpValue<=0)
        {
          arr[0].isShow=false;
        }
      }
      return arr;
    },
  },
  created() {
    this.from=Number(this.$route.query.from);
    this.pageInit();
  },
  methods: {
    pageInit(){
      if(!this.userInfo){
        return;
      }
      var params={
        payId:this.$route.query.payId,
      }
      if(this.userInfo.LoginAccountType==2){
        params['loginCompanyId']=this.userInfo.LoginAccountId;
      }else
      if(this.userInfo.LoginAccountType==1){
        params['loginUserId']=this.userInfo.LoginAccountId;
      }
      GetAccountPayInfo(params).then(r=>{
        if(r.Result==1){
          this.payInfo={...r.Data};
        }else{
          this.$toast(r.Message);
        }
      })
    },
    nextStep(){
      if(!this.typeId){
        this.$toast('请选择支付方式');
        return;
      }
      let that=this;
      if(this.typeId==1){
        this.alipay();
      }else if(this.typeId==2 || this.typeId==4){
        this.$password({
          async onConfirm (data){
            await that.submit(data);
            this.close();
          },
          onCancel(){
            this.close();
            that.$router.push('/center/accountProtect');
          }
        })
      }else if(this.typeId==3){
        this.wxpay();
      }
    },
    //余额/额度支付
    submit(password){
      var params={
        jobId:this.payInfo.ContentId,
        payId:this.$route.query.payId,
        payPwd:aesEncrypt(password,2),
      }
      if(this.userInfo.LoginAccountType==2){
        params['companyId']=this.userInfo.LoginAccountId;
      }else
      if(this.userInfo.LoginAccountType==1){
        params['userId']=this.userInfo.LoginAccountId;
      }
      if(this.typeId==4){
        CreditPay(params).then(r=>{
          if(r.Result==1){
            // let startTime=new Date(r.Data.ReleaseDate).getTime();//支付成功时间
            // let hour=this.payInfo.ResponseTime || 4;//响应时长
            // let endTime=startTime+hour*60*60*1000;//回应时间
            if(this.from==2){
              this.$router.go(-1);//如果从工单详情进来的，支付成功直接返回
            }else{
              this.$router.replace({
                path:'/paySuccess',
                query:{
                  // jobId:r.Data.JobId,
                  // targetTime:endTime,
                  // jobType:this.from==3?1:6,
                  // jobNo:this.payInfo.Number,
                  payId:this.$route.query.payId,
                }
              })
            }
          }else{
            this.$toast(r.Message);
          }
        })
      }else{
        BalancePay(params).then(r=>{
          if(r.Result==1){
            let startTime=new Date(r.Data.ReleaseDate).getTime();//支付成功时间
            let hour=this.payInfo.ResponseTime || 4;//响应时长
            let endTime=startTime+hour*60*60*1000;//回应时间
            if(this.from==2){
              this.$router.go(-1);
            }else{
              this.$router.replace({
                path:'/paySuccess',
                query:{
                  // jobId:r.Data.JobId,
                  // targetTime:endTime,
                  // jobType:this.from==3?1:6,
                  // jobNo:this.payInfo.Number,
                  payId:this.$route.query.payId,
                }
              })
            }
          }else{
            this.$toast(r.Message);
          }
        })
      }
    },
    //微信支付
    wxpay(){
      let data = {}
      data.jobId = this.payInfo.ContentId
      data.userCode = this.userInfo.UserCode
      data.payId = this.$route.query.payId
      let self = this
      PcWeiXinPay(data).then(r=>{
        if(r.Result){
          this.isShowQrcode=true;
          // // this.qrcode=r.Data.CodeUrl;
          this.count = r.Data.PayMoney
          this.getQrcode(r.Data.QrCodeUrl);
          self.time = setInterval(() => {
          //定时刷新订单状态
            this.payment(r.Data.GkAlipayId);
          }, 1000);
        }
      })
      
      // WeixinUnifiedorderByPC({
      //   UserCode:this.userInfo.UserCode,
      //   RechargeMoney:this.count,
      // }).then(r=>{
      //   if(r.Result){
      //     this.isShowQrcode=true;
      //     // this.qrcode=r.Data.CodeUrl;
      //     this.getQrcode(r.Data.CodeUrl);
      //   }
      // })
    },
    // 微信是否支付成功
    payment(gkId){
      let data = {}
      data.gkAlipayId = gkId
      WeiXinQueryOrder(data).then(res=> {
        if(res.Data.IsPaySuccess) {
          // let startTime=new Date(r.Data.ReleaseDate).getTime();//支付成功时间
          // let hour=this.payInfo.ResponseTime || 4;//响应时长
          // let endTime=startTime+hour*60*60*1000;//回应时间
          this.$router.replace({
            path:'/paySuccess',
            query:{
              // jobId:this.payInfo.ContentId,
              // jobType:this.from==3?1:6,
              // targetTime:endTime,
              // jobNo:this.payInfo.Number,
              payId:this.$route.query.payId,
            }
          })
          this.clearWeiXin()
        }
      })
    },
    // 关闭微信支付
    clearWeiXin(){
      this.isShowQrcode = false
      clearInterval(this.time)
    },
    //支付宝支付
    alipay(){
      let data = {}
      data.jobId = this.payInfo.ContentId
      data.userCode = this.userInfo.UserCode
      data.payId = this.$route.query.payId
      PcAliPay(data).then(res=>{
        if(res.Result==1){
          window.location.href=res.Data.AlipayUrl ;
        }
      })
      // AliConfirmRecharge({
      //   Money:this.count,
      //   UserCode:this.userInfo.UserCode
      // }).then(r=>{
      //   if(r.Result==1){
      //     window.location.href=r.Data.Body;
      //   }
      // })
    },
    //获取验证码
    getQrcode(url){
      let opts = {
        errorCorrectionLevel: "H",//容错级别
        type: "image/png",//生成的二维码类型
        quality: 0.3,//二维码质量
        margin: 0,//二维码留白边距
        width: 180,//宽
        height: 180,//高
        text: url,//二维码内容
        color: {
          dark: "#333333",//前景色
          light: "#fff"//背景色
        }
      };
      QRCode.toCanvas(this.$refs.qrcode,url,opts,(err)=>{
        console.log(err)
      })
    }
  },
}
</script>
<style lang="scss">
.payment-page{
  .header-main {
    width: 1000px;
  }
  .container{
    width: 1000px;
    margin: 0 auto;
    background-color: #fff;
    padding-top: 70px;
    overflow: hidden;
  }
  .title-module{
    margin-top: 40px;
    margin-bottom: 50px;
    // height: 50px;
    overflow: hidden;
    border-bottom: 1px solid #e5e5e5;
    .title{
      font-size: 16px;
      font-weight: bold;
      line-height: 50px;
      color: #333;
      float: left;
    }
    .icon{
      display: inline-block;
      vertical-align: middle;
      width: 28px;
      height: 30px;
      background: url('~@/assets/balance/sp-logo.png') no-repeat center;
      margin-right: 5px;
      margin-top: -3px;
    }
    .fr{
      float: right;
    }
    .label{
      font-size: 14px;
      color: #999;
      line-height: 24px;
    }
    .count{
      font-size: 22px;
      color: #f75959;
      font-weight: bold;
      font-family: 'DIN-Regular';
      line-height: 50px;
      .unit{
        font-size: 14px;
      }
    }
    .pay-info{
      float: left;
      width: 100%;
      height: 40px;
      line-height: 40px;
      margin-bottom: 10px;
      padding-left: 40px;
    }
    .pay-name{
      float: left;
      font-size: 18px;
      color: #333;
      font-weight: bold;
      margin-right: 40px;
    }
    .order-no{
      font-size: 14px;
      color: #333;
    }
  }
  .form{
    .form-item{
      margin-bottom: 20px;
      overflow: hidden;
    }
    .label{
      float: left;
      font-size: 16px;
      color: #666;
      line-height: 40px;
      font-weight: bold;
      width: 150px;
      text-align: right;
      padding-right: 20px;
    }
    .input{
      float: left;
      width: 100px;
      height: 30px;
      padding-left: 12px;
      padding-right: 12px;
      color: #333;
      font-size: 14px;
      font-weight: bold;
      line-height: 28px;
      border: 1px solid #ccc;
      margin-top: 10px;
      &:focus{
        border-color: #f75959;
      }
    }
    .unit{
      float: left;
      font-size: 14px;
      color: #999;
      line-height: 30px;
      margin-top: 10px;
      margin-left: 10px;
    }
    .value{
      font-size: 16px;
      color: #f75959;
      font-weight: bold;
      font-family: 'DIN-Regular';
      padding-left: 20px;
    }
    .input-box{
      float: left;
      width: 600px;
    }
    .radiobox{
      position: relative;
      overflow: hidden;
      margin-bottom: 10px;
      width: 600px;
      height: 50px;
      display: block;
      .radio{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        font-size: 600px;
        opacity: 0;
      }
      .radio-block{
        border: 1px solid #e5e5e5;
        height: 50px;
        line-height: 50px;
        padding-left: 60px;
        &:before{
          content: "";
          position: absolute;
          left: 20px;
          top: 50%;
          margin-top: -7px;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border: 1px solid #ccc;
          background-color: #fff;
          padding: 2px;
          box-sizing: border-box;
        }
      }
      .radio:checked+.radio-block{
        border-color: #f75959;
        &:before{
          background-color: #f75959;
          border-color: #f75959;
          background-clip: content-box;
        }
      }
      .icon-payment{
        width: 28px;
        height: 28px;
        background-repeat: no-repeat;
        background-position: center;
        display: inline-block;
        vertical-align: middle;
        background-size: contain;
        margin-right: 20px;
        margin-top: -3px;
      }
      .text{
        font-size: 14px;
        color: #333;
        font-weight: bold;
      }
    }
  }
  .btn-primary{
    width: 180px;
    height: 44px;
    margin-left: 150px;
    display: block;
    margin-top: 50px;
    font-size: 16px;
  }
  .tips{
    margin-left: 150px;
    margin-top: 30px;
    .tips-title{
      font-size: 14px;
      color: #333;
      line-height: 24px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p{
      font-size: 14px;
      color: #999;
      line-height: 24px;
    }
  }
  .wxpay-dialog{
    .dialog-body{
      text-align: center;
      padding-top: 30px;
    }
    .name{
      font-size: 14px;
      color: #999;
      line-height: 30px;
    }
    .price{
      font-size: 24px;
      color: #f75959;
      font-weight: bold;
    }
    .qrcode{
      display: block;
      width: 180px;
      height: 180px;
      margin: 20px auto;
    }
    .desc{
      font-size: 14px;
      color: #333;
      line-height: 24px;
    }
  }
}
</style>